import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { useLocation } from "react-router";

import HandleQuery from "@components/HandleQuery";
import ClientPage from "@components/pageTypes/ClientPage";
import ScheduleSession from "@components/schedule/ScheduleSession";
import useSubscribeToJourney from "@hooks/subscriptions/useSubscribeToJourney";
import {
  GetJourneyWithExpertAndConsultsDocument,
  GetJourneyWithExpertAndConsultsQuery,
  GetJourneyWithExpertAndConsultsQueryVariables
} from "@typing/Generated";
import { dateAtCurrentTime } from "@utils/timeUtils";

type Props = {
  journeyId: string;
};

const ExpertJourneyScheduleSessionPage = ({ journeyId }: Props) => {
  const location = useLocation();
  const defaultDate = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    const paramDate = searchParams.get("defaultDate");
    if (paramDate) {
      return dateAtCurrentTime(paramDate);
    }
    return null;
  }, [location.search]);

  const getJourneyWithExpertAndConsultsQuery = useQuery<
    GetJourneyWithExpertAndConsultsQuery,
    GetJourneyWithExpertAndConsultsQueryVariables
  >(GetJourneyWithExpertAndConsultsDocument, {
    variables: { id: journeyId }
  });

  useSubscribeToJourney(journeyId, () => {
    getJourneyWithExpertAndConsultsQuery.refetch();
  });

  return (
    <ClientPage gradient={false} helmetKey="pageTitles.client.schedule.show" journeyId={journeyId}>
      <HandleQuery query={getJourneyWithExpertAndConsultsQuery}>
        {journeyData => <ScheduleSession defaultDate={defaultDate} journey={journeyData.journey} />}
      </HandleQuery>
    </ClientPage>
  );
};

export default ExpertJourneyScheduleSessionPage;
